import { GET_AUTOMATION_BULK_ACTION_LIST, GET_AUTOMATION_BULK_ACTION_LIST_ERROR, GET_AUTOMATION_LOG_LIST, GET_AUTOMATION_LOG_LIST_ERROR, GET_AUTOMATION_PAY_PERIOD_LIST, GET_AUTOMATION_PAY_PERIOD_LIST_ERROR, GET_AUTOMATION_RESULT_DETAILS, GET_AUTOMATION_RESULT_DETAILS_ERROR, GET_PROCESS_LIST, GET_PROCESS_LIST_ERROR, RESET_AUTOMATION_DETAIL } from "../../actions/types"

const initialState = {
    automationPayPeriodList: [],
    processList: [],
    automationLogList: [],
    automationResultData: {},
    automationActions: [],
}
export default function automation(state = initialState, action) {

    switch (action.type) {
        case GET_AUTOMATION_PAY_PERIOD_LIST:
            return {
                ...state,
                automationPayPeriodList: action.payload.data
            }
        case GET_AUTOMATION_PAY_PERIOD_LIST_ERROR:
            return {
                ...state,
                automationPayPeriodList: initialState.automationPayPeriodList
            }
        case GET_PROCESS_LIST:
            return {
                ...state,
                processList: action.payload.data
            }
        case GET_PROCESS_LIST_ERROR:
            return {
                ...state,
                processList: initialState.processList
            }

        case GET_AUTOMATION_LOG_LIST:
            return {
                ...state,
                automationLogList: action.payload.data
            }
        case GET_AUTOMATION_LOG_LIST_ERROR:
            return {
                ...state,
                automationLogList: []
            }
        case GET_AUTOMATION_RESULT_DETAILS:
            return {
                ...state,
                automationResultData: action.payload.data
            }
        case GET_AUTOMATION_RESULT_DETAILS_ERROR:
        case RESET_AUTOMATION_DETAIL:
            return {
                ...state,
                automationResultData: []
            }
        case GET_AUTOMATION_BULK_ACTION_LIST:
            return {
                ...state,
                automationActions: action.payload.data
            }
        case GET_AUTOMATION_BULK_ACTION_LIST_ERROR: {
            return {
                ...state,
                automationActions: []
            }
        }
        default:
            return { ...state }
    }

}